import { cn } from "@synthesis/shared-utils";
import { Tooltip } from "@synthesis/shared-ui";

import { useApplicationHistory } from "../../hooks/use-application-history";
import { DetailTabPlaceholder } from "../detail-tab-placeholder";
import { UserAvatar } from "../user-avatar";
import { UserNameInformation } from "../user-name-information";

type ActionHistoryContentProps = {
  applicationId: string;
  className?: string;
};

export const ActionHistoryContent = ({ applicationId, className }: ActionHistoryContentProps) => {
  const { entries, isLoading } = useApplicationHistory(applicationId ?? "");

  if (isLoading) {
    return <p className="paragraph-sm text-type-minor py-4 text-center">Загрузка истории действий...</p>;
  }

  if (entries.length === 0) {
    return (
      <DetailTabPlaceholder
        className={className}
        title="История действий пуста"
        description="Здесь будут отображаться действия пользователей по заявке"
      />
    );
  }

  return (
    <div className={cn("flex flex-col", className)}>
      {entries.map((entry, index) => (
        <div key={entry.id}>
          <div className="flex flex-wrap items-center gap-1.5">
            <div className="flex items-center gap-3">
              <UserAvatar initials={entry.userInitials} />
              <UserNameInformation name={entry.userName} email={entry.userEmail} triggerClassName="subtitle-sm text-type-common font-medium" />
            </div>
            <span className="paragraph-sm text-type-minor">→</span>
            {entry.tooltip ? (
              <Tooltip description={entry.tooltip} arrowAlign="center" arrowSide="top">
                <span className="subtitle-sm text-type-common cursor-default font-medium">{entry.action}</span>
              </Tooltip>
            ) : (
              <span className="subtitle-sm text-type-common font-medium">{entry.action}</span>
            )}
            <span className="paragraph-sm text-type-light">{entry.occurredAt}</span>
          </div>

          {index < entries.length - 1 && <div className="bg-neutrals-90 ml-[15px] h-4 w-px" aria-hidden />}
        </div>
      ))}
    </div>
  );
};
